import { Flex, Box, Image } from "@chakra-ui/react";
import { t } from "i18next";
import { FunnelComponentProps } from "../../funnel/types";
import { ReleasePurchaseData } from "./ReleasePurchaseData";
import { useIsSmallBreakpoint } from "../../../utils/useBreakpoints";
import { useEffect, useRef } from "react";
import { useIsVisible } from "../../../hooks/useIsVisible";
import { EventTypes } from "../../../screens/root/api/eventsApi";
import { CollectibleBadge } from "../../cards/components/CollectibleBadge";
import { ReleasePriceLabel } from "../../cards/ReleasePriceLabel";
import { CollectibleIndicator } from "./CollectibleIndicator";
import { PurchaseReleaseModalFooter } from "./PurchaseReleaseModalFooter";
import { DiscountBanner } from "./DiscountBanner";
import { useUserData } from "../../../hooks/useUserData";
import { FunnelSteps } from "../../funnel/FunnelSteps";

export function PurchaseReleaseModalBody(funnelProps: FunnelComponentProps) {
  const {
    release,
    sendEvent,
    shouldShowSteps,
    stepCount,
    currentStep,
    stepText,
    stepDisplayText,
    showStepIndicators,
  } = funnelProps;
  const isSmallBreakpoint = useIsSmallBreakpoint();
  const { userData } = useUserData();

  const ref = useRef<HTMLDivElement>(null);
  const isVisible = useIsVisible(ref, 0.5);
  const alreadyTracked = useRef(false);

  useEffect(() => {
    if (sendEvent && isVisible && !alreadyTracked.current) {
      sendEvent(EventTypes.viewed_alc_offer);
      alreadyTracked.current = true;
    }
  }, [isVisible]);

  if (!release) return null;
  return (
    <Flex flexDirection="column" gap="24px" width={"100%"} padding="24px" ref={ref}>
      {shouldShowSteps && (
        <FunnelSteps
          stepCount={stepCount}
          currentStep={currentStep}
          stepText={stepText}
          text={stepDisplayText}
          hideProgressIndicators={!showStepIndicators}
        />
      )}
      <Flex flexDirection="row" width="fit-content" alignSelf="center">
        <Image
          borderRadius="10px"
          height={isSmallBreakpoint ? "139px" : "215px"}
          aspectRatio={0.645}
          src={release.thumbnail_url}
          alt="Release thumbnail"
          mr={6}
        />
        <Flex flexDirection="column">
          <Box mb="20px">
            <CollectibleBadge />
          </Box>
          <ReleasePurchaseData
            pagesTextSuffix={t("components.payments.purchaseRelease.pages")}
            release={release}
          />
          {release?.release_user_purchase ? null : (
            <Box mt="20px">
              <ReleasePriceLabel
                release={release}
                fontSize="16px"
                hideAvailableDiscounts
                hideFreeWithGold
              />
            </Box>
          )}
        </Flex>
      </Flex>
      <Box width="100%" height="1px" background="transparent.white.10" />
      <Flex gap="8px" flexDirection="column" alignItems="center">
        {userData?.gold ? (
          <DiscountBanner release={release} isGold={userData?.gold} />
        ) : null}
        <CollectibleIndicator />
      </Flex>
      <PurchaseReleaseModalFooter release={release} {...funnelProps} />
    </Flex>
  );
}
